import CaseSelectDialog from "./CaseSelectDialog";

const components = {
    CaseSelectDialog
}

export default components